const sectionStyle = { marginTop: "24px" };
const subTitleStyle = { marginTop: "16px" };

const PrivacyPage = () => {
  return (
    <div style={{ width: "80%", margin: "auto", paddingBottom: "40px" }}>
      <h2 style={{ textAlign: "center" }}>CHÍNH SÁCH BẢO MẬT</h2>
      <p style={{ textAlign: "center" }}>
        Áp dụng cho ứng dụng TanvanKids — Hệ thống Giáo dục Tân Văn
        <br />
        Cập nhật lần cuối: 27/10/2026
      </p>

      <section style={sectionStyle}>
        <h3>1. Giới thiệu</h3>
        <p>
          Chính sách bảo mật này giải thích cách ứng dụng TanvanKids ("Ứng
          dụng") thu thập, sử dụng, lưu trữ và chia sẻ thông tin của người
          dùng. Bằng việc sử dụng Ứng dụng, người dùng đồng ý với các nội dung
          dưới đây.
        </p>
      </section>

      <section style={sectionStyle}>
        <h3>2. Thông tin chúng tôi thu thập</h3>

        <h4 style={subTitleStyle}>
          2.1. Thông tin tài khoản (do phụ huynh/giáo viên cung cấp khi đăng
          ký)
        </h4>
        <ul>
          <li>Địa chỉ email và mật khẩu</li>
          <li>Họ tên, số điện thoại, địa chỉ (nếu có cung cấp)</li>
          <li>
            Thông tin học tập của trẻ: tiến độ bài học, kết quả luyện tập
          </li>
        </ul>

        <h4 style={subTitleStyle}>2.2. Dữ liệu từ quyền truy cập thiết bị</h4>
        <ul>
          <li>
            <strong>Micro (ghi âm):</strong> Ứng dụng sử dụng micro cho các
            bài tập luyện nói/phát âm. File ghi âm được lưu{" "}
            <strong>tạm thời trên thiết bị</strong> để người dùng tự nghe lại,{" "}
            <strong>
              không được gửi lên máy chủ hoặc chia sẻ với bên thứ ba
            </strong>
            .
          </li>
          <li>
            <strong>Internet:</strong> dùng để tải nội dung bài học (âm thanh,
            video) và đồng bộ tài khoản.
          </li>
        </ul>

        <h4 style={subTitleStyle}>2.3. Dữ liệu chẩn đoán kỹ thuật</h4>
        <p>
          Ứng dụng dùng <strong>Firebase Crashlytics</strong> (dịch vụ của
          Google) để ghi nhận lỗi khi ứng dụng gặp sự cố, nhằm cải thiện chất
          lượng. Dữ liệu được gửi gồm: loại lỗi, model thiết bị, phiên bản hệ
          điều hành, phiên bản ứng dụng. Dữ liệu này{" "}
          <strong>
            không chứa thông tin định danh cá nhân trực tiếp
          </strong>{" "}
          (không gồm tên, email, số điện thoại).
        </p>
      </section>

      <section style={sectionStyle}>
        <h3>3. Chúng tôi KHÔNG thu thập/làm gì</h3>
        <ul>
          <li>
            Không tích hợp SDK quảng cáo, không thu thập dữ liệu để quảng cáo
            hoặc bán dữ liệu cho bên thứ ba.
          </li>
          <li>
            Không thu thập dữ liệu thanh toán trong ứng dụng (thanh toán khóa
            học thực hiện ngoài ứng dụng qua chuyển khoản/tại chi nhánh).
          </li>
          <li>Không tải lên hoặc lưu trữ file ghi âm trên máy chủ.</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h3>4. Mục đích sử dụng thông tin</h3>
        <ul>
          <li>Tạo và quản lý tài khoản học tập</li>
          <li>Cung cấp, cá nhân hoá nội dung khóa học theo tiến độ của trẻ</li>
          <li>Hỗ trợ kỹ thuật, xử lý khiếu nại</li>
          <li>Phát hiện và khắc phục lỗi kỹ thuật của ứng dụng</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h3>5. Chia sẻ thông tin với bên thứ ba</h3>
        <p>
          Chúng tôi <strong>không bán hoặc cho thuê</strong> thông tin cá nhân
          của người dùng. Thông tin chỉ được chia sẻ trong các trường hợp:
        </p>
        <ul>
          <li>
            Với <strong>Google Firebase</strong> (hạ tầng ghi nhận lỗi kỹ
            thuật — Crashlytics), theo{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noreferrer"
            >
              Chính sách bảo mật của Google
            </a>
          </li>
          <li>
            Khi <strong>pháp luật yêu cầu</strong> (cơ quan nhà nước có thẩm
            quyền)
          </li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h3>6. Trẻ em và vai trò của phụ huynh/giáo viên</h3>
        <p>
          Ứng dụng dành cho trẻ em sử dụng dưới sự giám sát của phụ
          huynh/giáo viên. Tài khoản được phụ huynh/giáo viên tạo và quản lý;
          chúng tôi không thu thập trực tiếp thông tin cá nhân từ trẻ em ngoài
          phạm vi phụ huynh/giáo viên cung cấp.
        </p>
      </section>

      <section style={sectionStyle}>
        <h3>7. Bảo mật thông tin</h3>
        <p>
          Mật khẩu và thông tin tài khoản được lưu trữ bảo mật. Người dùng có
          trách nhiệm giữ kín mật khẩu và đăng xuất sau khi sử dụng trên thiết
          bị chung.
        </p>
      </section>

      <section style={sectionStyle}>
        <h3>8. Quyền của người dùng</h3>
        <p>Người dùng có quyền:</p>
        <ul>
          <li>
            Xem, cập nhật, chỉnh sửa thông tin cá nhân của mình/con em ngay
            trong ứng dụng
          </li>
          <li>
            Yêu cầu xóa tài khoản và dữ liệu cá nhân bằng cách liên hệ thông
            tin ở mục 10
          </li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h3>9. Thay đổi chính sách</h3>
        <p>
          Chính sách này có thể được cập nhật. Thay đổi quan trọng sẽ được
          thông báo trước ít nhất 7 ngày qua ứng dụng hoặc email.
        </p>
      </section>

      <section style={sectionStyle}>
        <h3>10. Liên hệ</h3>
        <p>
          HỆ THỐNG GIÁO DỤC TÂN VĂN
          <br />
          Địa chỉ: 66 Phạm Văn Chiêu, Phường 8, Quận Gò Vấp, TP.HCM
          <br />
          Hotline: 0916.119.117
          <br />
          Email: hethonggiaoduc@tanvan.edu.vn
        </p>
      </section>

      <p style={{ marginTop: "32px" }}>
        Xem thêm:{" "}
        <a href="/terms">Điều khoản sử dụng (Quy định chung)</a>
      </p>
    </div>
  );
};

export default PrivacyPage;
